import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { IPartialSearchService } from './partial-search-service.interface';
import { PartialSearch } from './partial-search.model';

// RxJs
import { of, Observable, throwError } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, finalize, switchMap, tap } from 'rxjs/operators';



@Component({
  selector: 'pgs-partial-search',
  templateUrl: './partial-search.component.html',
  styleUrls: ['./partial-search.component.scss']
})
export class PartialSearchComponent {

  @Input() label: string;
  @Input() placeholder: string;
  @Input() errorMsg: string;
  @Input() service: IPartialSearchService;
  @Input() showSearchButton = true;
  @Input() searchByTitle = true;

  /*eslint-disable */ @Output() onResult = new EventEmitter<string>(); /*eslint-enable */
  @Output() hasValue = new EventEmitter<boolean>();

  loading = false;
  searchFailed = false;
  searchString: string = null;

  constructor() { }

  formatter = (x: { title: string }) => x.title;

  search = (text$: Observable<string>) => text$.pipe(
    tap((val) => this.hasValue.emit(!!val)),
    debounceTime(1000),
    distinctUntilChanged(),
    tap((val) => {
      if (this.searchFailed) {
        this.searchFailed = false;
      }
    }),
    switchMap(term => {
      if (term.length < 11) {
        return of([]);
      }
      this.loading = true;
      return this.service.searchPartial(term)
      .pipe(
        tap((results: PartialSearch[]) => {
          if (!results || results.length === 0) {
            this.searchFailed = true;
          } else {
            this.searchFailed = false;
          }
        }),
        catchError(() => {
          this.searchFailed = true;
          return throwError(() => []);
        }),
        finalize(() => this.loading = false )
      );
    })
  )

  selectResult(ev: NgbTypeaheadSelectItemEvent): void {
    this.searchString = ev.item.title;
    this.onResult.emit(this.searchByTitle ? ev.item.title : ev.item.subtitle);
    this.searchString = null;
    this.hasValue.emit(false);
  }

  searchByButton(): void {
    if (this.searchString && this.searchString.length) {
      this.onResult.emit(this.searchString);
      this.searchString = null;
    }
  }
}
